module.exports = __webpack_public_path__ + "img/message-cricle.8d792c78.svg";